import * as R from 'ramda';
import LangEnum from '../../lang/LangEnum';
import PATHS from '../../routes/routes.const';
import { RouteConfig } from '../../routes/routes.types';

export const flattenRoutes = (routesObj: typeof PATHS): RouteConfig[] => {
  const getRoutes = (
    currentLevelObj: {
      [key: string]: any;
    },
    parentPageTitleKey?: LangEnum,
  ): RouteConfig[] => {
    return Object.keys(currentLevelObj).reduce((acc: RouteConfig[], key: string) => {
      const value = currentLevelObj[key];

      if (R.is(Object, value) && value !== null) {
        if (typeof value.path === 'string') {
          const routeCopy: RouteConfig = { ...value };

          if (!routeCopy.pageTitleKey && parentPageTitleKey) {
            routeCopy.pageTitleKey = parentPageTitleKey;
          }

          acc.push(routeCopy);
        }

        const nextParentPageTitleKey =
          typeof value.pageTitleKey !== 'undefined' ? value.pageTitleKey : parentPageTitleKey;

        const nestedRoutes = getRoutes(value, nextParentPageTitleKey);
        return acc.concat(nestedRoutes);
      }
      return acc;
    }, []);
  };

  const allRoutes: RouteConfig[] = getRoutes(routesObj);

  const filteredRoutes = allRoutes.filter((route) => R.has('pageTitleKey', route));

  return filteredRoutes;
};
